import type Combatant from "./Combatant.ts";

// Transport data; the Character is shared by all tokens using the same template.
export type CombatantData = Omit<Combatant, "character"> & {characterId: string};

export function toCombatantData(combatant: Combatant): CombatantData {
    const {character, ...data} = combatant;
    return {...data, characterId: character.id};
}
